export const STEP_DESCRIPTIONS = [
	"Detalles del evento",
	"Vista previa y confirmación",
];
export const INITIAL_FORM = {
	fileData: {
		name: "",
		size: 0,
		base64: "",
	},
};
export const INITIAL_ERRORS = {
	fileData: false,
};